import { Link, useSearchParams } from 'react-router-dom';
import { Check } from 'lucide-react';

export default function OrderConfirmedPage() {
  const [params] = useSearchParams();
  const number = params.get('n');
  return (
    <div data-testid="order-confirmed-page" className="max-w-3xl mx-auto px-6 py-32 text-center">
      <div className="w-14 h-14 mx-auto rounded-full bg-lum-text text-lum-bg flex items-center justify-center mb-6">
        <Check />
      </div>
      <p className="overline mb-3">Order received</p>
      <h1 className="font-serif-display text-5xl md:text-6xl leading-[1.05]">Your ritual is on the way.</h1>
      {number && <p className="mt-6 text-lum-text2">Order number: <span className="text-lum-text">{number}</span></p>}
      <p className="mt-4 text-lum-text2 max-w-lg mx-auto">Check your inbox in the next hour for a secure payment link and shipping confirmation. Your free gift will be packed alongside your masks.</p>
      <Link to="/shop" className="btn-primary mt-10 inline-flex">Continue shopping</Link>
    </div>
  );
}
